import { useSyncExternalStore } from "react";
import type { PluginUI } from "@magic-md/plugin-sdk";
import { getPluginUI, pluginUIRegistry } from "../plugins/plugin-ui-registry";

export function usePluginRegistryVersion(): number {
    return useSyncExternalStore(
        pluginUIRegistry.subscribe,
        pluginUIRegistry.revision,
        pluginUIRegistry.revision,
    );
}

export function usePluginUI(pluginName: string | null | undefined): PluginUI | null {
    usePluginRegistryVersion();
    return pluginName ? (getPluginUI(pluginName) ?? null) : null;
}
